
/**
 * SEO 配置 - models (Norsk)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 | WeryAI',
        description: 'Experience Google Veo 3.1 on WeryAI. High-quality results.',
        keywords: 'Google Veo 3.1, AI, WeryAI',
    },
    veo_3: {
        title: 'veo 3 | WeryAI',
        description: 'Experience veo 3 on WeryAI. High-quality results.',
        keywords: 'veo_3, AI, WeryAI',
    },
    veo_3_fast: {
        title: 'veo 3 fast | WeryAI',
        description: 'Experience veo 3 fast on WeryAI. High-quality results.',
        keywords: 'veo_3_fast, AI, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 | Fysikknøyaktig AI-videogenerator | WeryAI',
        description: 'Generer realistiske, fysikknøyaktige AI-videoer med OpenAI Sora 2 med synkronisert lyd og narrativ konsistens.',
        keywords: 'Sora 2, OpenAI Sora, videomodel, realistisk AI video, tekst til video, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 | WeryAI',
        description: 'Experience WeryAI Video 1.0 on WeryAI.',
        keywords: 'WeryAI Video 1.0, AI, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2 - Nativ AI-Bildegenerator | WeryAI',
        description: 'Bruk WeryAI Image 2 for fantastisk nativ AI-bildegenerering! Flaggskipsmodell med avansert stilkontroll. Gratis kreditter, ingen kort nødvendig.',
        keywords: 'WeryAI Image 2, nativ AI-bildegenerator, flaggskips AI-bilde, studiokvalitet AI, WeryAI Image gratis, hvordan bruke WeryAI Image 2, WeryAI',
    },
    image_grok_2: {
        title: 'Gratis Grok 2 - xAI Bildegenerator | WeryAI',
        description: 'Bruk Grok 2 på WeryAI for kreative AI-bilder! xAI-modell med kunstnerisk fleksibilitet og unike stiler. Gratis kreditter, ingen kort nødvendig.',
        keywords: 'Grok 2, Grok AI, xAI bildegenerator, AI-kunst, kreative AI-bilder, Grok 2 gratis, hvordan bruke Grok 2, WeryAI',
    },
    image_nano_banana_2: {
        title: 'Nano Banana 2 Bildgenerator Googles nyeste | WeryAI',
        description: 'Nano Banana 2 drevet av Gemini med verdenskunnskap og sanntidssøk. Generer faktisk nøyaktige, fantastiske bilder med ultrarask hastighet.',
        keywords: 'Nano Banana 2, Google AI, Gemini, bildegenerering, tekstgjengivelse, flersubjektkonsistens, 4K, WeryAI',
        og_title: 'Nano Banana 2 Bildegenerator | WeryAI',
        og_description: 'Nano Banana 2 drives av Gemini med dyp verdensforståelse og sanntidssøk, og genererer bilder som er både vakre og faktisk nøyaktige.',
        twitter_title: 'Nano Banana 2 Bildegenerator | WeryAI',
        twitter_description: 'Nano Banana 2 drives av Gemini med dyp verdensforståelse og sanntidssøk, og genererer bilder som er både vakre og faktisk nøyaktige.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        ogImageAlt: 'Nano Banana 2 AI-bildegenerator',
        twitterImageAlt: 'Nano Banana 2 AI-bildegenerator',
    },
    kling_ai: {
        title: 'Kling 2.5 Turbo | Kinematisk AI Videogenerator | WeryAI',
        description: 'Kling 2.5 Turbo lager kinematiske videoer med avansert linsekontroll, følelsesmessige uttrykk og jevn bevegelsesfysikk.',
        keywords: 'Kling 2.5 Turbo, Kling AI, kinematisk AI video, linsekontroll AI, WeryAI',
    },
    runway_ai: {
        title: 'Runway Gen-4 Avansert AI-videogenerator | WeryAI',
        description: 'Runway Gen-4 genererer realistiske, konsistente AI-videoer med dypere promptforståelse og smarte redigeringsverktøy. Prøv det gratis på WeryAI.',
        keywords: 'Runway Gen-4, Runway AI, AI-videogenerator, tekst til video, bilde til video, AI-videoredigering, WeryAI',
    },
    hailuo_23: {
        title: 'hailuo 23 | WeryAI',
        description: 'Experience hailuo 23 on WeryAI. High-quality results.',
        keywords: 'hailuo_23, AI, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI Videogenerator - Avansert Videoproduksjon | WeryAI',
        description: 'Generer avanserte AI-videoer med Hailuo AI på WeryAI. Har banebrytende bevegelseskontroll og realistisk rendering.',
        keywords: 'Hailuo AI, MiniMax, AI videogenerator, bevegelseskontroll, realistisk video, WeryAI',
    },
    pika_2_2: {
        title: 'pika 2 2 | WeryAI',
        description: 'Experience pika 2 2 on WeryAI. High-quality results.',
        keywords: 'pika_2_2, AI, WeryAI',
    },
    seedance: {
        title: 'Seedance AI videogenerator Dans og bevegelse | WeryAI',
        description: 'Seedance AI videogenerator - Dans og bevegelse skapelse on WeryAI. Realistic and professional results.',
        keywords: 'seedance, AI, WeryAI',
    },
    seedance_2: {

        title: 'Werydance 2.0 - Regissørnivå AI-videogenerator | WeryAI',

        description: 'Lag regissørnivå AI-videoer med Werydance 2.0: multimodale referanser, narrativ konsistens og fysikksimulering. Gratis på WeryAI.',

        keywords: 'Werydance 2.0, Seedance AI, weryai, AI videogenerator, regissørnivå video, multimodal video, fysikksimulering, leppesynkronisering, tekst til video, gratis AI video, WeryAI',

        og_title: 'Werydance 2.0 - Regissørnivå AI-videogenerator | WeryAI',

        og_description: 'Lag regissørnivå AI-videoer med Werydance 2.0: multimodale referanser, narrativ konsistens og fysikksimulering. Gratis på WeryAI.',

        twitter_title: 'Werydance 2.0 - Regissørnivå AI-videogenerator | WeryAI',

        twitter_description: 'Lag regissørnivå AI-videoer med Werydance 2.0: multimodale referanser, narrativ konsistens og fysikksimulering. Gratis på WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Werydance 2.0 AI Video Generator',

        twitterImageAlt: 'Werydance 2.0 AI Video Generator',

    },
    image_nano_banana_pro: {
        title: 'Gratis Nano Banana Pro - AI-Bildegenerator | WeryAI',
        description: 'Bruk Nano Banana Pro på WeryAI for AI-bilder med høyeste kvalitet! Konkurrerer med Midjourney i kvalitet. Gratis kreditter, ingen kort nødvendig.',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, Google AI-bilde, reasoning AI-bilde, 4K AI-bilde, Nano Banana Pro gratis, hvordan bruke Nano Banana Pro, WeryAI',
    },
    image_nano_banana: {
        title: 'Gratis Nano Banana - AI-Bildegenerator | WeryAI',
        description: 'Bruk Nano Banana på WeryAI for å lage AI-bilder enkelt! Allsidig og rask AI-bildemodell. Gratis kreditter, ingen kort nødvendig.',
        keywords: 'Nano Banana, Gemini 2.5 Flash, Google AI-bilde, rask AI-generator, karakterkonsistens, Nano Banana gratis, hvordan bruke Nano Banana, WeryAI',
    },
    image_flux: {
        title: 'Gratis FLUX - Prøv AI-Bildegenerator | WeryAI',
        description: 'Bruk FLUX på WeryAI for å generere fantastiske AI-bilder! Bygget av Stable Diffusion-teamet med eksepsjonell visuell kvalitet. Gratis kreditter, ingen kort nødvendig.',
        keywords: 'FLUX, FLUX AI, Black Forest Labs, AI-bildegenerator, tekst til bilde, AI-kunst, FLUX gratis, hvordan bruke FLUX, WeryAI',
    },
    image_flux_kontext: {
        title: 'Gratis FLUX Kontext - Pro AI-Bilderedigerer | WeryAI',
        description: 'Bruk FLUX Kontext på WeryAI for profesjonell AI-bilderedigering! Overlegen presisjon, avansert typografi og flertrinnredigering. Gratis kreditter, ingen kort nødvendig.',
        keywords: 'FLUX Kontext, FLUX.1 Kontext, AI-bilderedigerer, profesjonelle AI-bilder, typografi AI, FLUX Kontext gratis, hvordan bruke FLUX Kontext, WeryAI',
    },
    image_imagen: {
        title: 'Gratis Imagen 4 - Google AI-Bildegenerator | WeryAI',
        description: 'Bruk Google Imagen 4 på WeryAI for fotorealistiske AI-bilder! Allsidig stilkontroll og presis tekstgenerering. Gratis kreditter, ingen kort nødvendig.',
        keywords: 'Imagen 4, Google Imagen, Google AI-bildegenerator, tekst til bilde, fotorealistisk AI, Imagen gratis, hvordan bruke Imagen 4, WeryAI',
    },
    image_qwen_image: {
        title: 'Gratis Qwen Image - Alibaba AI-Bildemodell | WeryAI',
        description: 'Bruk Qwen Image på WeryAI for flerspråklig AI-kunst! Alibaba open-source modell med overlegen tekstrendering. Gratis kreditter, ingen kort nødvendig.',
        keywords: 'Qwen Image, Alibaba AI, open-source AI-bilde, flerspråklig tekstrendering, Qwen Image gratis, hvordan bruke Qwen Image, WeryAI',
    },
    image_wan_ai: {
        title: 'Gratis Wan AI - Alibaba Bildegenerator | WeryAI',
        description: 'Bruk Wan AI på WeryAI for AI-bilder med høy troskap! Alibaba-modell med presis prompt-følging og fotorealistisk rendering. Gratis kreditter, ingen kort nødvendig.',
        keywords: 'Wan AI, Wan 2.5, Alibaba AI-bildegenerator, tekst til bilde, fotorealistisk AI, Wan AI gratis, hvordan bruke Wan AI, WeryAI',
    },
    image_seendream: {
        title: 'Gratis Seedream 4.0 - ByteDance Bilde AI | WeryAI',
        description: 'Bruk Seedream 4.0 på WeryAI for ultrarask AI-bildegenerering! ByteDance-modell med varierte kunststiler. Gratis kreditter, ingen kort nødvendig.',
        keywords: 'Seedream, Seedream 4.0, ByteDance bilde AI, ultrarask AI-bilde, kunstneriske AI-stiler, Seedream gratis, hvordan bruke Seedream, WeryAI',
    },
    image_dreamina: {
        title: 'Gratis Dreamina 4.0 - Multimodal Bilde AI | WeryAI',
        description: 'Bruk Dreamina 4.0 på WeryAI for multimodal AI-bildeskapelse! Skisse til bilde, stiloverføring og karakterfusjon. Gratis kreditter, ingen kort nødvendig.',
        keywords: 'Dreamina 4.0, ByteDance bilde AI, multimodal AI-bilde, skisse til bilde, stiloverføring, Dreamina gratis, hvordan bruke Dreamina 4.0, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Gratis Seedream 4.5 - ByteDance Bilde AI | WeryAI',
        description: 'Bruk Seedream 4.5 på WeryAI for flaggskips AI-bildegenerering! Nyeste ByteDance med presis typografi. Gratis kreditter, ingen kort nødvendig.',
        keywords: 'Seedream 4.5, ByteDance bilde AI, flaggskipsmodell, typografi rendering, multi-bilde fusjon, Seedream 4.5 gratis, hvordan bruke Seedream 4.5, WeryAI',
    },
    image_seedream_5_0: {
        title: 'Seedream 5.0 ByteDance Ultimat AI | WeryAI',
        description: 'Seedream 5.0 er ByteDances mesterverk innen AI-visuell med nativ 8K-kvalitet, ultimat semantisk forståelse, multi-subjekt komposisjon og tekstrendering 2.0. Prøv gratis på WeryAI.',
        keywords: 'Seedream 5.0, AI bildegenerering, 8K kvalitet, semantisk forståelse, multi-subjekt komposisjon, tekstrendering, ByteDance, WeryAI',
        og_title: 'Seedream 5.0 Bildegenerator | WeryAI',
        og_description: 'Seedream 5.0 er ByteDances mesterverk innen AI-visuell generering med nativ 8K-kvalitet, ultimat semantisk forståelse, multi-subjekt komposisjon og avansert tekstrendering.',
        twitter_title: 'Seedream 5.0 Bildegenerator | WeryAI',
        twitter_description: 'Seedream 5.0 er ByteDances mesterverk innen AI-visuell generering med nativ 8K-kvalitet, ultimat semantisk forståelse, multi-subjekt komposisjon og avansert tekstrendering.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        ogImageAlt: 'Seedream 5.0 AI-bildegenerator',
        twitterImageAlt: 'Seedream 5.0 AI-bildegenerator',
    },
    image_recraft_v4_vector: {
        title: 'Recraft V4 Vector - Profesjonell AI Vektorgrafikk Generator | WeryAI',
        description: 'Recraft V4 Vector er en profesjonell AI vektorgrafikk generator fra Recraft.ai som genererer redigerbare SVG vektorer med tapsfri skalering, presis typografi og kontroll av merkestil. Prøv gratis på WeryAI nå.',
        keywords: 'Recraft V4 Vector, AI vektorgenerering, SVG generator, ekte vektor, logodesign, UI ikoner, vektorillustrasjon, Recraft, WeryAI',
    },
    image_midjourney: {
        title: 'Gratis Midjourney - Prøv AI-Kunstgenerator | WeryAI',
        description: 'Bruk Midjourney på WeryAI for å lage kunstneriske AI-bilder! Kjent for fantastisk estetikk og lyskvalitet. Gratis kreditter, ingen kort nødvendig.',
        keywords: 'Midjourney, Midjourney AI, AI-kunstgenerator, kunstneriske AI-bilder, Midjourney gratis, Midjourney alternativ, hvordan bruke Midjourney, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 AI Video Generator | WeryAI',
        description: 'Skap fantastiske videoer med Runway Gen-4.5 på WeryAI. Hybrid autoregressiv-diffusjons arkitektur for presis fysikk simulering og tidsmessig konsistens.',
        keywords: 'Runway Gen-4.5, AI video generator, kinoklar AI video, fysikk simulering, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro AI Video Generator | WeryAI',
        description: 'Generer høy kvalitet videoer med Kling 2.6 Pro på WeryAI. Native audiovisuell generering, kinokvalitet 1080p, fremragende prompt overholdelse.',
        keywords: 'Kling 2.6 Pro, AI video generator, høy kvalitet AI video, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Video Generator Presis kamera kontroll | WeryAI',
        description: 'Generer kinoklare AI videoer med Dreamina 3.0 (Jimeng 3.0) på WeryAI. Presis start/slutt frame kontroll, profesjonelle kamerabevegelser og 1080p høy-dynamisk video generering.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, AI video generator, kamera kontroll, start slutt frame, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 AI Video Generator Kreativ Video | WeryAI',
        description: 'Frigjør din kreativitet på WeryAI med Kling O1 AI video generator. Perfekt for å generere fantasifull og unik videoinnhold.',
        keywords: 'Kling O1, AI video generator, kreativ AI video, Kling AI, WeryAI',
    },
    kling_3_0: {

        title: 'Kling 3.0 - Intelligent AI-videogenerator | WeryAI',

        description: 'Lag AI-videoer med Kling 3.0: intelligent storyboarding, flerspråklig leppesynkronisering og presis tekstgjengivelse. Gratis på WeryAI.',

        keywords: 'Kling 3.0, Kling AI, Kuaishou, AI videogenerator, intelligent storyboarding, leppesynkronisering, tekstgjengivelse, tekst til video, bilde til video, gratis AI video, WeryAI',

        og_title: 'Kling 3.0 - Intelligent AI-videogenerator | WeryAI',

        og_description: 'Lag AI-videoer med Kling 3.0: intelligent storyboarding, flerspråklig leppesynkronisering og presis tekstgjengivelse. Gratis på WeryAI.',

        twitter_title: 'Kling 3.0 - Intelligent AI-videogenerator | WeryAI',

        twitter_description: 'Lag AI-videoer med Kling 3.0: intelligent storyboarding, flerspråklig leppesynkronisering og presis tekstgjengivelse. Gratis på WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Kling 3.0 AI Video Generator',

        twitterImageAlt: 'Kling 3.0 AI Video Generator',

    },
    vidu_q3: {

        title: 'Vidu Q3 - Nativ 16s lyd-video AI-generator | WeryAI',

        description: 'Generer nativ 16-sekunders lyd-video med Vidu Q3: smart klipping, presis tekstgjengivelse og flerspråklig leppesynkronisering. Gratis på WeryAI.',

        keywords: 'Vidu Q3, Vidu AI, AI videogenerator, nativ 16s lyd-video, intelligent storyboarding, tekstgjengivelse, leppesynkronisering, tekst til video, bilde til video, gratis AI video, WeryAI',

        og_title: 'Vidu Q3 - Nativ 16s lyd-video AI-generator | WeryAI',

        og_description: 'Generer nativ 16-sekunders lyd-video med Vidu Q3: smart klipping, presis tekstgjengivelse og flerspråklig leppesynkronisering. Gratis på WeryAI.',

        twitter_title: 'Vidu Q3 - Nativ 16s lyd-video AI-generator | WeryAI',

        twitter_description: 'Generer nativ 16-sekunders lyd-video med Vidu Q3: smart klipping, presis tekstgjengivelse og flerspråklig leppesynkronisering. Gratis på WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Vidu Q3 AI Video Generator',

        twitterImageAlt: 'Vidu Q3 AI Video Generator',

    },
    image_gpt_4o: {
        title: 'Gratis GPT-4o - OpenAI Bildegenerator | WeryAI',
        description: 'Bruk GPT-4o på WeryAI for å lage bilder gjennom samtale! OpenAI med presis tekstrendering og høy kvalitet. Gratis kreditter, ingen kort nødvendig.',
        keywords: 'GPT-4o, GPT-4o bilde, OpenAI bildegenerator, samtale AI-kunst, GPT-4o gratis, hvordan bruke GPT-4o bilder, WeryAI',
    },
    image_gpt_image_1_5: {
        title: 'Gratis GPT Image 1.5 - OpenAI Kunstgenerator | WeryAI',
        description: 'Bruk GPT Image 1.5 på WeryAI for neste generasjons AI-kunst! Nyeste OpenAI-modell med forbedret kreativitet. Gratis kreditter, ingen kort nødvendig.',
        keywords: 'GPT Image 1.5, OpenAI bildemodell, AI-kunstgenerator, neste gen AI, GPT Image 1.5 gratis, hvordan bruke GPT Image 1.5, WeryAI',
    },
}
